// Cache variables for loaded data
let cachedWilayas = null;
let cachedCommunes = null;
let cachedStopdesks = null;
let cachedDeliveryTypes = null;
let cachedHomeDeliveryPrices = null;

// --- Load Data from JSON Files ---

async function loadDeliveryTypesFromFile() {
  if (cachedDeliveryTypes) return cachedDeliveryTypes;
  try {
    const deliveryTypesResponseUrl = window.DELIVERY_TYPES_JSON_URL;
    const response = await fetch(deliveryTypesResponseUrl);
    const data = await response.json();
    cachedDeliveryTypes = data.data;
    return cachedDeliveryTypes;
  } catch (error) {
    console.error('Error loading delivery types from file:', error);
    return [];
  }
}

async function loadWilayasFromFile() {
  if (cachedWilayas) return cachedWilayas;

  try {
    const wilayasResponseUrl = window.WILAYAS_JSON_URL;
    const response = await fetch(wilayasResponseUrl);
    const data = await response.json();

    // Extract unique wilayas from the data
    const wilayasMap = new Map();

    data.data.forEach((item) => {
      if (item && !wilayasMap.has(item.id)) {
        wilayasMap.set(item.id, {
          id: item.id,
          name: item.name,
        });
      }
    });

    cachedWilayas = Array.from(wilayasMap.values());
    return cachedWilayas;
  } catch (error) {
    console.error('Error loading wilayas from file:', error);
    return [];
  }
}

async function loadCommunesFromFile() {
  if (cachedCommunes) return cachedCommunes;

  try {
    const communesResponseUrl = window.COMMUNES_JSON_URL;
    const response = await fetch(communesResponseUrl);
    const data = await response.json();

    // Extract communes data
    cachedCommunes = data.data.map((item) => ({
      id: item.id,
      name: item.name,
      wilaya_id: item.wilaya_id,
    }));

    return cachedCommunes;
  } catch (error) {
    console.error('Error loading communes from file:', error);
    return [];
  }
}

async function loadStopdesksFromFile() {
  if (cachedStopdesks) return cachedStopdesks;

  try {
    const stopdesksResponseUrl = window.STORE_STOPDESKS_JSON_URL;
    const response = await fetch(stopdesksResponseUrl);
    const data = await response.json();

    cachedStopdesks = data.data;
    return cachedStopdesks;
  } catch (error) {
    console.error('Error loading stopdesks from file:', error);
    return [];
  }
}

async function loadHomeDeliveryPricesFromFile() {
  if (cachedHomeDeliveryPrices) return cachedHomeDeliveryPrices;

  try {
    const homeDeliveryPricesResponseUrl = window.STORE_DELIVERY_TYPES_JSON_URL;
    const response = await fetch(homeDeliveryPricesResponseUrl);
    const data = await response.json();

    cachedHomeDeliveryPrices = data.data;
    return cachedHomeDeliveryPrices;
  } catch (error) {
    console.error('Error loading home delivery prices from file:', error);
    return [];
  }
}

// --- Wilayas (all wilayas, no filtering) ---
async function fillWilayas() {
  const wilayaSelect = document.getElementById('wilaya');
  try {
    const wilayas = await loadWilayasFromFile();

    // Clear previous options and show ALL wilayas (no filtering)
    wilayaSelect.innerHTML = '<option value="">-- Sélectionnez une wilaya --</option>';
    wilayas.forEach((w) => {
      const opt = document.createElement('option');
      opt.value = w.id;
      //opt.textContent = w.name;
      opt.textContent = `${w.id} - ${w.name}`;
      opt.setAttribute('data-name', w.name);
      wilayaSelect.appendChild(opt);
    });
  } catch (err) {
    console.error('Erreur chargement wilayas:', err);
  }
}

// --- Communes for Stop Desk (only communes with stopdesks) ---
async function fillCommunesForStopDesk(wilayaId) {
  const communeSelect = document.getElementById('commune');
  try {
    // Get all communes from static data
    const allCommunes = await loadCommunesFromFile();

    // Filter communes for the selected wilaya
    const communes = allCommunes.filter((c) => c.wilaya_id == wilayaId);

    // Get stopdesks to filter communes that have offices
    const stopdesks = await loadStopdesksFromFile();

    // Get unique commune IDs that have stopdesks
    const communesWithStopdesks = [...new Set(stopdesks.map((s) => s.commune_id))];

    // Filter communes to only show those with stopdesks
    const availableCommunes = communes.filter((c) => communesWithStopdesks.includes(c.id));

    // clear previous options
    communeSelect.innerHTML = '<option value="">-- Sélectionnez une commune --</option>';
    availableCommunes.forEach((c) => {
      const opt = document.createElement('option');
      opt.value = c.id;
      opt.textContent = c.name;
      opt.setAttribute('data-name', c.name);
      communeSelect.appendChild(opt);
    });

    // attach listener to load offices when a commune is selected - handled by global listener
  } catch (err) {
    console.error('Erreur chargement communes pour stop desk:', err);
  }
}

// --- Offices ---
async function fillOffices(communeId) {
  const officeSelect = document.getElementById('office');
  try {
    // Get stopdesks data from static data
    const stopdesks = await loadStopdesksFromFile();

    // Filter stopdesks for the selected commune
    let offices = stopdesks.filter((o) => o.commune_id == communeId);

    // Get sorted array so that 'ZR Express' is last
    offices = sortZrExpressToLast(offices, o => o.partner_company_name);

    // clear previous options
    officeSelect.innerHTML = '<option value="">-- Sélectionnez une agence --</option>';
    offices.forEach((o) => {
      const opt = document.createElement('option');
      opt.value = o.office_id; // Use office_id from stopdesks

      // Define major cities to clean from partner_company_name
      const majorCities = ['Alger', 'Constantine', 'Sétif', 'Oran'];

      // Clean partner_company_name by removing city names
      let cleanedPartnerName = o.partner_company_name;
      majorCities.forEach((city) => {
        cleanedPartnerName = cleanedPartnerName.replace(new RegExp(city, 'gi'), '').trim();
      });

      // Create display text with cleaned partner name and price
      const displayText = `${o.price} DA - ${cleanedPartnerName} (${o.address})`;

      opt.textContent = displayText;
      opt.setAttribute('data-name', o.office_name); // keep name accessible
      opt.setAttribute('data-address', o.address); // keep address accessible
      opt.setAttribute('data-partner', cleanedPartnerName); // keep partner company name accessible
      opt.setAttribute('data-price', o.price); // keep price accessible
      officeSelect.appendChild(opt);
    });

    // attach listener to update cart (save attributes) when a office is selected - handled by global listener
  } catch (err) {
    console.error('Erreur chargement offices:', err);
  }
}

// --- New functions for home delivery flow ---
async function fillCommunesForHomeDeliveryByWilaya(wilayaId) {
  const communeSelect = document.getElementById('commune');
  try {
    const allCommunes = await loadCommunesFromFile();
    // Filter and sort alphabetically by name for home delivery communes
    const communes = allCommunes
      .filter(c => c.wilaya_id == wilayaId)
      .sort((a, b) => a.name.localeCompare(b.name, 'fr', { sensitivity: 'base' }));
    communeSelect.innerHTML = '<option value="">-- Sélectionnez une commune --</option>';
    communes.forEach(c => {
      const opt = document.createElement('option');
      opt.value = c.id;
      opt.textContent = c.name;
      opt.setAttribute('data-name', c.name);
      communeSelect.appendChild(opt);
    });
  } catch (err) {
    console.error('Erreur chargement communes (home flow nouvelle logique):', err);
  }
}

async function fillHomeDeliveryCompaniesForCommune(wilayaId, communeId) {
  const deliveryCompanySelect = document.getElementById('deliveryCompany');
  try {
    const [deliveryTypes, homeDeliveryPrices] = await Promise.all([
      loadDeliveryTypesFromFile(),
      loadHomeDeliveryPricesFromFile()
    ]);

    // Map type id -> display name (apply same renaming rules used previously)
    const nameMap = new Map();
    deliveryTypes.forEach(type => {
      let label = type.name;
      if (type.name === 'Express') label = 'Zimou express';
      else if (type.name === 'Economy Express') label = 'Zimou envoi économique (délai plus long)';
      nameMap.set(String(type.id), { original: type.name, label });
    });

    // For each delivery type prices entry, check for commune match
    let companiesWithPrice = [];
    homeDeliveryPrices.forEach(entry => {
      const priceObj = entry.prices.find(p => p.commune_id == communeId && p.wilaya_id == wilayaId);
      if (priceObj && priceObj.delivery_price && Number(priceObj.delivery_price) > 0) {
        companiesWithPrice.push({
          delivery_id: entry.delivery_id,
          price: priceObj.delivery_price
        });
      }
    });

    // Get sorted array so that 'ZR Express' is last
    companiesWithPrice = sortZrExpressToLast(companiesWithPrice, c => nameMap.get(String(c.delivery_id))?.label);

    // Clear and repopulate select
    deliveryCompanySelect.innerHTML = '<option value="">-- Sélectionnez une société --</option>';

    if (companiesWithPrice.length === 0) {
      const opt = document.createElement('option');
      opt.value = '';
      opt.textContent = 'Aucune société ne dessert cette commune';
      opt.disabled = true;
      deliveryCompanySelect.appendChild(opt);
      return;
    }

    companiesWithPrice.forEach(c => {
      const mapping = nameMap.get(String(c.delivery_id));
      if (!mapping) return; // skip if no name mapping found
      // Exclude relais types (Point relais etc.) from home delivery choices
      if (/relais/i.test(mapping.original) || /relais/i.test(mapping.label)) return;
      const opt = document.createElement('option');
      opt.value = c.delivery_id;
      opt.setAttribute('data-name', mapping.original);
      opt.setAttribute('data-price', c.price);
      opt.textContent = `${c.price} DA - ${mapping.label}`;
      deliveryCompanySelect.appendChild(opt);
    });
  } catch (err) {
    console.error('Erreur chargement sociétés pour commune sélectionnée:', err);
  }
}

// Utility: Returns a new array sorted so that entries with 'ZR Express' in the given field are last
function sortZrExpressToLast(arr, getName) {
  return [...arr].sort((a, b) => {
    const aName = (getName(a) || '').toLowerCase();
    const bName = (getName(b) || '').toLowerCase();
    if (aName.includes('zr express') && !bName.includes('zr express')) return 1;
    if (bName.includes('zr express') && !aName.includes('zr express')) return -1;
    return 0;
  });
}
